var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.infoSidebar.info_sidebar),expression:"infoSidebar.info_sidebar"}],staticClass:"info-sidebar-container"},[_c(_vm.getCurrentComponnet,{tag:"component",attrs:{"detail-info":_vm.infoSidebar.info_details,"info-sidebar-id":_vm.infoSidebar.info_sidebar_id}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd78b40a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfomationSidebar/index.vue
// module id = null
// module chunks = 